import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

export interface InputProps {
    name?: string;
    value?: boolean;
    label?: string | ReactNode;
    isDefault?: boolean;
    className?: string;
    // eslint-disable-next-line no-unused-vars
    onChange: (value: boolean, name: string | undefined) => void;
}

const StyledField = styled.input`
    appearance: none;
    -webkit-appearance: none;
`;

const CheckBoxStyle = styled.span<{ checked: boolean }>`
    ${({ theme: { colors }, checked }) => `
        border: 1px solid ${checked ? colors.primary : colors.text.tertiary};
        position: relative;
        width: 14px;
        height: 14px;
        border-radius: 40%;
        &:hover {
            border-color: ${colors.primary};
        }
        &:before {
            content: '';
            width: 70%;
            height: 70%;
            top: 0;
            left: 0;
            bottom: 0px;
            right: 0;
            position: absolute;
            margin: auto;
            background: ${checked ? colors.primary : 'transparent'};
            border-radius: 40%;
        }
    `}
`;

const StyledLabel = styled.label`
    ${({ theme: { colors, typography } }) => `
        display: flex;
        align-items: center;
        cursor: pointer;
        color: ${colors.text.secondary};
        font-size: ${typography.size.desktop.paragraph.p3};
        &:hover{
            .styled-checkbox:before, .styled-radio-shape {
                border-color: ${colors.primary};
            }
        }
    `}
`;

const StyledDefaultCheckbox = styled.input`
    ${({ theme: { colors } }) => `
        margin: 0px;    
        margin-right: 8px;
        position: relative;
        cursor: pointer;

        :before {
            content: '';
            position: absolute;
            width: 13px;
            height: 13px;
            top: 0;
            left: 0;
            border: 1px solid ${colors.text.primary};
            border-radius: 3px;
            padding: 1px;
            background-color: ${colors.background.primary};
        }

        :checked:before {
            background-color: ${colors.primary};
            border: 1px solid ${colors.primary};
        }

        :checked:after {
            content: '';
            display: block;
            width: 4px;
            height: 8px;
            border: solid white;
            border-width: 0 2px 2px 0;
            -webkit-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
            position: absolute;
            top: 2px;
            left: 5px;
        }
    `}
`;

const Checkbox: FC<InputProps> = ({ name, value, label, isDefault, className, onChange }) => {
    const handleChange = () => {
        onChange(!value, name);
    };
    return (
        <StyledLabel>
            {isDefault ? (
                <StyledDefaultCheckbox
                    type="checkbox"
                    className={classNames('styled-checkbox', className)}
                    onChange={handleChange}
                    checked={value}
                />
            ) : (
                <>
                    <CheckBoxStyle className="styled-radio-shape" checked={value!} />
                    <StyledField
                        className={classNames('styled-checkbox', className)}
                        onChange={handleChange}
                        checked={value}
                        name={name}
                        type="checkbox"
                        id={name}
                    />
                </>
            )}
            {label}
        </StyledLabel>
    );
};

export { Checkbox };
